import { z } from "zod";

/**
 * HabilidadeItemSchema
 */

export const HabilidadeItemSchema = z.object({
  idHabilidade: z.coerce.number({ invalid_type_error: 'Este campo deve ser selecionado!' }),
  nota: z.coerce.number({ invalid_type_error: 'Este campo deve ser selecionado!' }),
});

/**
 * HabilidadeItemForm
 */

export type HabilidadeItemForm = z.infer<typeof HabilidadeItemSchema>;